import {trail} from '../path/shapes.js';
import {pickTrail} from '../util/pickPath.js';
import markMultiItemPath from './markMultiItemPath.js';

export default markMultiItemPath('trail', trail, pickTrail);
